import ApplicationService from '@baserow/modules/core/services/application'

/**
 * Origem Flow: Central de modelos — os "modelos do workspace" são aplicações
 * comuns marcadas com este prefixo no nome. Salvar como modelo = duplicar a
 * aplicação e renomear a cópia com o prefixo; usar um modelo = duplicar a
 * aplicação-modelo e renomear a cópia sem o prefixo.
 */
export const TEMPLATE_PREFIX = '[Modelo] '

export function isTemplateApplication(application) {
  return (application.name || '').startsWith(TEMPLATE_PREFIX)
}

export function templateDisplayName(application) {
  return isTemplateApplication(application)
    ? application.name.slice(TEMPLATE_PREFIX.length)
    : application.name
}

/**
 * Duplica a aplicação de forma assíncrona (job `duplicate_application`) e,
 * quando o job termina, renomeia a cópia para `newName`. Resolve com o
 * objeto da aplicação duplicada. `vm` é o componente chamador (usado para
 * $client, $store e $watch do estado reativo do job).
 */
export async function duplicateApplicationAndRename(vm, application, newName) {
  const { data: rawJob } = await ApplicationService(vm.$client).asyncDuplicate(
    application.id
  )
  const storeJob = await vm.$store.dispatch('job/create', rawJob)

  return await new Promise((resolve, reject) => {
    const unwatch = vm.$watch(
      () => storeJob.state,
      async (state) => {
        if (state === 'finished') {
          unwatch()
          const duplicated =
            vm.$store.getters['application/get'](
              storeJob.duplicated_application.id
            ) || storeJob.duplicated_application
          try {
            await vm.$store.dispatch('application/update', {
              application: duplicated,
              values: { name: newName },
            })
            resolve(duplicated)
          } catch (error) {
            reject(error)
          }
        } else if (['failed', 'cancelled'].includes(state)) {
          unwatch()
          reject(
            new Error(storeJob.human_readable_error || 'Duplication failed')
          )
        }
      }
    )
  })
}
